/* ==========================================================================
   PRFORM Scroll Reveal
   IntersectionObserver for .prform-reveal elements.

   Loaded on EVERY page. This matters: prform-animations.css sets
   .prform-reveal { opacity: 0 } globally, so any page using the class
   without this script running renders its text permanently invisible.
   This lived inside prform-oslo-fade.js, which theme.liquid loads only
   when template.name == 'index'.
   ========================================================================== */

(function () {
  'use strict';

  var revealElements = document.querySelectorAll('.prform-reveal');
  if (!revealElements.length) return;

  function revealAll() {
    for (var i = 0; i < revealElements.length; i++) {
      revealElements[i].classList.add('prform-reveal--visible');
    }
  }

  /* No observer support, or motion suppressed — show everything at once
     rather than leaving it transparent. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduceMotion) {
    revealAll();
    return;
  }

  var revealObserver = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        var el = entries[i].target;
        var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
        setTimeout(function (element) {
          element.classList.add('prform-reveal--visible');
        }, delay, el);
        revealObserver.unobserve(el);
      }
    }
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });

  for (var j = 0; j < revealElements.length; j++) {
    revealObserver.observe(revealElements[j]);
  }

  /* Safety net: an element taller than the viewport can fail to reach the
     0.15 threshold. Anything still hidden after load gets shown. */
  window.addEventListener('load', function () {
    setTimeout(function () {
      for (var k = 0; k < revealElements.length; k++) {
        var el = revealElements[k];
        if (el.classList.contains('prform-reveal--visible')) continue;
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('prform-reveal--visible');
          revealObserver.unobserve(el);
        }
      }
    }, 400);
  });
})();
